import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "./router";
import { App } from "./App";
import { LanguageProvider } from "./state/language";
import "./styles.css";
import { authenticateTelegram } from "./api";
import { ErrorBoundary } from "./ErrorBoundary";
import { installClientMonitoring } from "./monitoring";

installClientMonitoring();
window.Telegram?.WebApp.ready();
window.Telegram?.WebApp.expand();
async function bootstrap() {
  const root = createRoot(document.getElementById("root")!);
  try {
    await authenticateTelegram();
    root.render(
      <StrictMode>
        <ErrorBoundary>
          <BrowserRouter>
            <LanguageProvider>
              <App />
            </LanguageProvider>
          </BrowserRouter>
        </ErrorBoundary>
      </StrictMode>,
    );
  } catch (error) {
    const ru = localStorage.getItem("vektor-language") === "ru";
    const code =
      error && typeof error === "object" && "code" in error
        ? String(error.code)
        : "";
    root.render(
      <div className="bootstrap-state">
        <span className="brand-mark">V</span>
        <p className="eyebrow">VEKTOR MARKETS</p>
        <h1>
          {ru
            ? "Откройте приложение в Telegram"
            : "Ilovani Telegram ichida oching"}
        </h1>
        <p>
          {error instanceof Error
            ? error.message
            : ru
              ? "Не удалось выполнить авторизацию."
              : "Autentifikatsiya bajarilmadi."}
        </p>
        <a className="primary-button" href="https://t.me/ForexPulse_robot">
          {ru ? "Открыть бота" : "Botni ochish"}
        </a>
        {code !== "TELEGRAM_REQUIRED" && (
          <button
            className="secondary-button"
            onClick={() => location.reload()}
          >
            {ru ? "Повторить" : "Qayta urinish"}
          </button>
        )}
      </div>,
    );
  }
}
void bootstrap();
